import { Pipe, PipeTransform } from '@angular/core';

import { authorColor } from '../../../core/utils/author-color';

@Pipe({
  name: 'authorColor',
  standalone: false,
})
export class AuthorColorPipe implements PipeTransform {
  transform(seed?: string | null): string {
    return authorColor(seed);
  }
}
